import { awIntegrationsApi } from './Base';
import { AGraphCheckRestrictionsPayload, AGraphCheckRestrictionsResponse } from './types';

export const BASE_RESTRICTIONS_PATH = `/partners/restrictions/v1/restrictions:check`;
export function checkRestrictions(payload: AGraphCheckRestrictionsPayload) {
  return awIntegrationsApi.post<AGraphCheckRestrictionsResponse>(BASE_RESTRICTIONS_PATH, payload);
}
